import { QuoteType } from "../types/QuoteType";
import { FixAndFlipCalculation } from "./short-term/short-term-calculation.model";
import { FixAndFlipQuote } from "./short-term/short-term.model";
import { RentalCalculation } from "./rental/rental-calculation.model";
import { RentalQuote } from "./rental/rental.model";

export interface Quote {
  quoteName: string;
  createdOn: string;
  modifiedOn: string;
  id: number;
  quoteType: QuoteType;
  productType: string;
  isActive: boolean;
  quoteTypeLabel?: string;
  username: string;
  firstname: string;
  lastname: string;
  createdBy: string;
  underwriterStatus: string;
}

export class FixAndFlipQuoteDetail {
  in: FixAndFlipQuote;
  out: FixAndFlipCalculation;

  constructor(quote: FixAndFlipQuote, calculation: FixAndFlipCalculation) {
    this.in = quote;
    this.out = calculation;
  }
}

export class RentalQuoteDetail {
  in: RentalQuote;
  out: RentalCalculation;

  constructor(quote: RentalQuote, calculation: RentalCalculation) {
    this.in = quote;
    this.out = calculation;
  }
}
